import className from 'classnames/bind';
import styles from './ToastList.module.scss';
import ToastItem from '../ToastItem/ToastItem';
import { useRef } from 'react';

let cx = className.bind(styles);

export function ToastList({ data }) {
	const listRef = useRef(null);
  
	return Array.isArray(data) && data.length > 0 && (
		<div className={cx(['ns_toast-group', 'toast-group'])} aria-live="assertive" ref={listRef}>
			{data.map((toast) => (
				<ToastItem key={toast.id} id={toast.id} message={toast.message} type={toast.type} />
			))}
		</div>
	)
}
